export default {"src":"/_next/static/media/bgpattern.8b57a23f.svg","height":2960,"width":1440};